export const Dark = {
    mainBlack: '#000',
    whiteOpacity: 'rgba(255,255,255,0.76)',
    whiteOpacityGlobal: 'rgba(255,255,255,0.87)',
    whiteEditor: '#ccc',
    mainGrey: '#7d7d7d',
    lineGrey: '#343434',
    lineOpacity: '1px solid rgba(175,175,175,0.1)'
}